import { AfterViewInit, Component, ElementRef, Inject, signal, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { BucketService, FileNode, FolderNode } from 'src/app/services/bucket/bucket.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
@Component({
  selector: 'app-dialog-crea-cartella',
  standalone: false,

  templateUrl: './dialog-crea-cartella.component.html',
  styleUrl: './dialog-crea-cartella.component.scss',
})
export class DialogCreaCartellaComponent implements AfterViewInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChild('nameInput') nameInput!: ElementRef<HTMLInputElement>;

  public titolo: string = '';

  public form = new FormGroup({
    id: new FormControl<string>('', { nonNullable: true, validators: [] }),
    parentPath: new FormControl<string>('', { nonNullable: true, validators: [] }),
    name: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    path: new FormControl<string>('', { nonNullable: true, validators: [] }),
  });

  public errorMessage = signal('');

  constructor(
    public dialogRef: MatDialogRef<DialogCreaCartellaComponent>,
    private readonly _bucketService: BucketService,
    private readonly _utilityService: UtilityService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      tipo: 'FOLDER' | 'FILE';
      file?: FileNode;
      folder?: FolderNode;
      isCreazione?: boolean;
      listaFolders?: FolderNode[];
    },
  ) {
    this._init();
  }

  ngAfterViewInit() {
    // Metto autofocus sulla input della dialog
    setTimeout(() => this.nameInput.nativeElement.focus(), 0);
  }

  private _init(): void {
    const { folder, file, isCreazione } = this.data;

    this.titolo = 'Rinomina';
    // Set title
    if (folder && isCreazione) {
      this.titolo = 'Nuova cartella';
    }

    // Populate form with folder data
    if (folder && !isCreazione) {
      this._patchFormValues(folder);
    }

    // Populate form with file data
    if (file) {
      file.name = file.name.substring(0, file.name.lastIndexOf('.'));
      this._patchFormValues(file);
    }
  }

  private _patchFormValues(source: FileNode | FolderNode): void {
    Object.entries(source).forEach(([key, value]) => {
      const control = this.form.get(key);
      if (control) {
        control.setValue(value);
      }
    });
  }

  updateErrorMessage() {
    this.errorMessage.set('');
  }

  conferma() {
    if (this.form.invalid) {
      this.form.controls.name.markAsTouched();
      this.errorMessage.set('Nome cartella obbligatorio.');
      return;
    }

    if (this.data.folder) {
      this._salvaFolder();
    } else if (this.data.file) {
      this._salvaFile();
    } else {
      console.log('NON GESTITO');
    }
  }

  /**
   * Metodo di creazione della cartella oppure della modifica
   * Per la creazione passo la path del parentFolder, ovvero la path dove poi andrà creata la nuova cartella
   *
   * @returns
   */
  private _salvaFolder() {
    this.spinnerOver.show();
    const form = this.form.getRawValue();
    const parentFolder = this.data.folder;

    let path: string = '';

    // Se sono nelle prime 2 cartelle, non mando la path
    if (parentFolder && !parentFolder.locked) {
      path = parentFolder.path;
    }

    if (this.data.isCreazione && parentFolder) {
      this._bucketService
        .createFolderApi(path, form.name)
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (esito) => {
            console.log(esito);
            this.dialogRef.close(esito);
          },
          error: (err) => {
            this.errorMessage.set(err.error.message);
          },
        });
    } else {
      this._bucketService
        .updateFolderApi(form.name, form.id)
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (esito) => {
            console.log(esito);
            this.dialogRef.close(esito);
          },
          error: (err) => {
            this.errorMessage.set(err.error.message);
          },
        });
    }
  }

  /**
   * Modifca nome del file
   */
  private _salvaFile() {
    this.spinnerOver.show();
    const form = this.form.getRawValue();

    this._bucketService
      .updateFileName(form.name, form.id)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          console.log(esito);
          this.dialogRef.close(esito);
        },
        error: (err) => {
          this.errorMessage.set(err.error.message);
        },
      });
  }
}
